import app from "../authentication/firebaseStart";
import appConfig from '../data/application.properties';
import firebase from '../authentication/firebaseStart';
import axios from 'axios';
import firebaseUtil from '../data/FirebaseUtil';

const getToken = async () => {
  try{
    return (await app.auth().currentUser.getIdTokenResult()).token;
  }catch(err){
    return null;
  }
}

const instance = axios.create({
  baseURL: appConfig.BASE_URL,
});

// Add a request interceptor
instance.interceptors.request.use(async config => {
  //console.log("Inside Request Interceptors",config);
  let auth = true;
  if(config.method == "post" && config.data.hasOwnProperty("auth") && config.data.auth == false)
    auth = false

  if(auth){
    const token = await getToken();
    config.headers = {
      'authorization': `Bearer ${token}`,
    }
  }
  return config;
}, error=> {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(response => {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, async (error) => {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  console.log("User is logging out...")
  return Promise.reject(error);
});

export default instance;